<template>
    <div>
      <AppButton color="primary"
                 @click="openDialog = true"
      >
        {{ $t('common.upload') }}
      </AppButton>
      <AppDialog :is-open="openDialog"
                 size="l"
                 :ok-disabled="okDisabled"
                 :ok-loading="postSignedFilePending"
                 :cancel-disabled="postSignedFilePending"
                 @ok="preparePostSignedFile"
                 @cancel="resetAndClose"
      >
        <template #title>
          {{ $t('project.signing-checklist.pdf-signing.PdfSigningPmDialogEnvelopeUploadForUserDialog.title') }}
        </template>
        <template #body>
              <form @submit.stop.prevent="preparePostSignedFile">
                <v-row>
                  <v-col>
                    <h4 class="my-2">{{ $t('project.signing-checklist.pdf-signing.PdfSigningPmDialogEnvelopeUploadForUserDialog.forUser') }}</h4>
                    <AppSelect v-model="selectedUser"
                               name="user"
                               :items="signatories"
                               item-title="fullName"
                               item-value="id"
                               no-label
                               :placeholder="$t('project.signing-checklist.pdf-signing.PdfSigningPmDialogEnvelopeUploadForUserDialog.forUserPlaceholder')"
                    ></AppSelect>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <h4>{{ $t('project.signing-checklist.pdf-signing.PdfSigningPmDialogEnvelopeUploadForUserDialog.file') }}</h4>

                    <AppFileInput v-model="file"
                                  accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  prepend-icon=""
                                  variant="underlined"
                                  color="primary"
                                  density="comfortable"
                    >
                      <template #prepend-inner>
                        <app-icon
                          icon-name="paperclip"
                          icon-weight="fas"
                          size="small"
                          class="text-grey align-self-center"
                        />
                      </template>

                      <template #clear>
                        <app-icon
                          icon-name="circle-xmark"
                          icon-weight="fas"
                          size="small"
                          class="text-grey align-self-center"
                        />
                      </template>
                    </AppFileInput>
                  </v-col>
                </v-row>
              </form>
        </template>
      </AppDialog>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import AppFileInput from '@/common/AppFileInput.vue'
import AppSelect from '@/common/AppSelect.vue'
import AppButton from '@/common/buttons/AppButton.vue'
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { toast } from '@/common/utils/toast'
import signingChecklistService from '@/services/signingChecklist.service'
import { POST_SIGNED_FILE } from '@/store/modules/signing-checklist/action_types'

export default {
  name: 'PdfSigningPmDialogEnvelopeUploadForUserDialog',
  components: { AppFileInput, AppDialog, AppSelect, AppButton },
  props: {
    envelope: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      openDialog: false,
      selectedUser: null,
      file: null,
    }
  },
  computed: {
    ...mapState('signingChecklist', ['postSignedFilePending']),
    okDisabled () {
      return this.postSignedFilePending || (!this.selectedUser || !this.file)
    },
    signatories () {
      return this.envelope.signatories.flat()
    },
  },
  methods: {
    ...mapActions('signingChecklist', [POST_SIGNED_FILE]),
    async preparePostSignedFile () {
      try {
        const formData = new FormData()
        formData.append('signed_pages', this.file, this.file.name)
        formData.append('signer_id', this.selectedUser)
        await this.POST_SIGNED_FILE({
          mnemo: this.$route.params.mnemo,
          envelopeId: this.envelope.id,
          formData,
        })
        const response = await signingChecklistService.getEnvelopeSignatures(this.$route.params.mnemo, this.envelope.id)
        this.$emit('newSignatures', response.data.signatures)
        toast.success(this.$t('project.signing-checklist.pdf-signing.PdfSigningPmDialogEnvelopeUploadForUserDialog.postSignedFileSuccess'))
        this.resetAndClose()
      } catch (e) {
        toast.error(this.$t('project.signing-checklist.pdf-signing.PdfSigningPmDialogEnvelopeUploadForUserDialog.postSignedFileError'))
      }
    },
    resetAndClose () {
      this.file = null
      this.selectedUser = null
      this.openDialog = false
    },
  },
}
</script>
